/*
* This code is the intellectual property of Bulb Inc. and other software publishers;
* it may not be altered, copied or disclosed without prior written approval.
* Copyright 2021, Bulb Inc.  For more information, please email contact@hellobulb.com.
*                _
*  _            | | _
* | |         _ | || |
* | |__   _  | || || |__
* | '_ \ | | | || || '_ \
* | (_) || |_| || || (_) |
*  \___/  \___/ |_| \___/
*
*
*/

/**
 * @module bulbimage/utils
 */

import { type ViewDowncastWriter, toWidget, type ViewElement } from 'ckeditor5';
/**
 * Helper function to return the correct image asset. We always return the scaled image asset if one exists, otherwise
 * we return the full image asset.
 *
 * @param {image} imageBlock The image
 * @returns {image} image The scaled or full image assset.
 */
export function getDisplayedImageAsset(imageBlock) {
  return imageBlock.scaledImageAsset || imageBlock.fullImageAsset;
}

/**
 * Helper Function that returns the uncropped image asset for an image block if it has one.
 *
 * @return {*}
 */
// export function getUncroppedImageAsset(imageBlock) {
//   // For the cropping process, we *always* use the uncropped image asset if there is one, if not, we use the full
//   // image asset:
//   return imageBlock.uncroppedImageAsset || imageBlock.fullImageAsset;
// }

/**
 * Converts a given {@link module:engine/view/element~ViewElement} to an image widget:
 * * Adds a {@link module:engine/view/element~ViewElement#_setCustomProperty custom property}
 *   allowing to recognize the image widget element.
 * * Calls the {@link module:widget/utils~toWidget} function with the proper element's label creator.
 *
 * @param {module:engine/view/element~ViewElement} viewElement
 * @param {module:engine/view/downcastwriter~ViewDowncastWriter} writer An instance of the view writer.
 * @returns {module:engine/view/element~ViewElement}
 */
export function toImageWidget(viewElement: ViewElement, writer: ViewDowncastWriter): ViewElement {
  writer.setCustomProperty('image', true, viewElement);

  return toWidget(viewElement, writer, { label: 'Bulb Image', hasSelectionHandle: true });
}
